import React from 'react';
import i18n from 'src/utils/translate';
import { useHelpScout } from 'src/utils/hooks';
import { LinkButton } from 'styles-js/buttons';

const FollowSuccessMessage = ({communityName}) => {
  return (
    <span>
      {i18n.t("You're now a member of") + ' ' + communityName}. {' '}
      <LinkButton
        className="learn-more-link"
        onClick={() => useHelpScout('39-what-does-following-a-community-mean')}
      >
        {i18n.t('Learn more')}
      </LinkButton>
    </span>
  );
};

export default FollowSuccessMessage;
